import React, { useState } from 'react'
import styled from 'styled-components'
import Modal from 'react-modal'
import { merge } from 'lodash'
import TextArea from './TextArea'
import Actions from './Actions'
import theme from './theme'
import Icon from './Icon'

const style = {
  overlay: {
    zIndex: 100,
    backgroundColor: 'rgba(63,63,63,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  content: {
    minWidth: '500px',
    maxHeight: '80%',
    overflowY: 'auto',
    zIndex: 100,
    background: '#FFFFFF'
  }
}

const fullScreenStyle = {
  overlay: {
    zIndex: 100,
    backgroundColor: 'rgba(63,63,63,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  content: {
    width: '95%',
    height: '95%',
    overflowY: 'auto',
    zIndex: 100,
    background: '#FFFFFF'
  }
}
const StyledModal = styled(Modal)`
 .popup {
    min-width: 500px;
    max-height: 80%;
    overflow-y: auto;
    zIndex: 100;
    background: #FFFFFF;
 }
`
export default function Popup({ isOpen, onClose, children, styles, fullscreen = false, ...props }) {
  const customStyles = merge( fullscreen ? fullScreenStyle : style, styles)
  return <StyledModal
    isOpen={ isOpen }
    style={ customStyles }
    bodyOpenClassName={ 'fix-modal' }
    className="popup"
    contentClassName="modal-content"
    onRequestClose={ onClose }
  >
    { children }
  </StyledModal>
}

const ConfirmContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  > .title {
    height: 61px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    padding: 0px 20px;
    color: ${ theme.palette.white };
    background-color: ${ theme.palette.dark_blue };
  }
   > .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 20px;
    .actions {
      margin-top: 0px;
      margin-bottom: 0;
    }
    > div {
      display: flex;
      margin-top: 20px;
      > span {
        font-weight: bold;
        margin: 0 10px;
      }
    }
  }

`

export function Confirm({ title, onConfirm, onCancel, children, actionsOptions = {}, ...props }) {
  const {
    cancelButtonClass,
    direction,
    ...otherActionsOptions
  } = actionsOptions
  return <Popup { ...props } >
    <ConfirmContainer>
      { title && <div className='title'>{ title }</div> }
      <div className='content'>
        { children }
        <Actions
          cancelButtonClass={cancelButtonClass || 'inverse'}
          direction={direction || 'row-reverse'}
          onSubmit={ onConfirm }
          onCancel={ onCancel }
          {...otherActionsOptions}
        />
      </div>
    </ConfirmContainer>
  </Popup>
}
const WarningContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 20px;
  .bold {
    font-weight: bold;
    margin: 0;
  }
`

export function WarningConfirm ({children, ...props}) {
  return <Confirm {...props}>
    <Icon name="alert"/>
    <WarningContainer>
      {children}
    </WarningContainer>
  </Confirm>
}

const PromptContainer = styled.div`
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  > textarea {
    margin: 10px 0;
}`

export function Prompt({ title, onConfirm, onCancel, submitTxt, submitIcon, disableSubmit, maxRows, maxlength, ...props }) {
  const [msg, setMsg] = useState('')
  return <Popup { ...props } >
    <PromptContainer>
      <div className='title'>{ title }</div>
      <TextArea
        value={ msg }
        onValueChange={ setMsg }
        rows={ maxRows ? maxRows : 20 }
        maxlength={ maxlength }
      />
      <Actions
        submitTxt={ submitTxt }
        submitIcon={ submitIcon }
        disableSubmit={ disableSubmit || !msg }
        onSubmit={ () => {
          onConfirm && onConfirm(msg)
        } }
        onCancel={ onCancel }
      />
    </PromptContainer>
  </Popup>
}
